import RestClient from "../rest.client";

export default class GeneratePdfService {
    static async getBase64(plate: string, type: string, from: string, to: string, data: any) {
        return await RestClient.call({
            url: '/report/generate',
            method: 'post',
            data: {
                type,
                to,
                from,
                modem: 'Quecklink GV300',
                plate,
                data
            }
        }, process.env.VUE_APP_PDF_GENERATOR_API_URL)
    }
}
